import { useRef, useState } from "react";
import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import DeleteIcon from "@mui/icons-material/Delete";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";

import { Loader } from "../../common/loader";
import {
  encryptPayload,
  getObjLength,
  buildSignupPropertiesIdPayload,
} from "../../helpers/utils";
import { mapCreateUserApiUrl } from "../../for-service-provider/createUserApiPaths";
import AlertDialog from "../../common/AlertDialog";
import { userSigupAction } from "../../../redux/slices/user/userSignUpSlice";
import { propertiesAction } from "../../../redux/slices/properties/propertiesSlice";
import {
  PROPERTY_RISK_SUPPORT_PHONE,
  PROPERTY_RISK_SUPPORT_PHONE_FORMAT,
} from "../../helpers/constants";
import {
  complimentaryEnhancedFreeFlagPayload,
  isEldoradoFromWhere,
  isLoggedInSuperOrInternalAdmin,
} from "../../helpers/eldoradoSignup";
import { isAffiliateUser } from "../../helpers/affiliateSignup";
import { propertyUsersAction } from "../../../redux/slices/admin/propertyUsers/propertyUsersSlice";
import { isComplimentaryEnhancedMonitoringUser } from "../../admin/PropertyUsers/userDisplayHelpers";
import AdminCustomerCategoryModal, {
  ENHANCED_MONITORING_COMPLIMENTARY,
  shouldPromptAdminCustomerCategoryConfirm,
} from "./AdminCustomerCategoryModal";
import OwnerVerificationV2 from "../../user-signup/SignupTaiwindComponents/OwnerVerificationV2";

const OwnerVerification = ({
  isByPassOptionAvailable = false,
  isAdminCreateUser = false,
  selectedData = {},
  onChangeModalScreen = () => {},
  setFromPropertyList = () => {},
  setIsPropertyAdded = () => {},
  user_id = null,
  titleCompanyUser = {},
  isAssistant = false,
  isServiceProvider = false,
  category = "complete_protection",
  isAdmin = false,
  selectedRowData = {},
  setAdminChangeCategory = () => {},
  isTailwindComponent = false,
  skipVerification = false,
  setSkipVerification = () => {},
  finishMonitoringSignup = () => {},
  isResumeSignup = false,
  hideAddAnotherProperty = false,
  // C.A.R. (RE) agents skip this "Owner Verified" page and continue to the
  // next step as soon as the property list loads (cards 3853, 3856).
  autoContinue = false,
}) => {
  const [params, setParams] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [propertyName, setPropertyName] = useState("");
  const [propertyQuestionPopup, setPropertyQuestionPopup] = useState(false);
  const [openAdminCustomerCategoryModal, setOpenAdminCustomerCategoryModal] =
    useState(false);
  const [addMultiplePropertiesError, setAddMultiplePropertiesError] =
    useState("");
  const [
    showAddMultiplePropertiesSuccess,
    setShowAddMultiplePropertiesSuccess,
  ] = useState(false);
  const [selectedUpgradeCategory, setSelectedUpgradeCategory] = useState("");
  const [complimentaryEnrollResult, setComplimentaryEnrollResult] = useState({
    success: false,
    message: "",
  });
  const [showComplimentaryResult, setShowComplimentaryResult] = useState(false);
  const pendingComplimentaryEnhancedRef = useRef(false);
  const autoContinueRef = useRef({ requested: false, done: false });
  // Shown instead of the page while auto-continuing; an empty list falls back to it.
  const [autoContinueFailed, setAutoContinueFailed] = useState(false);

  const dispatch = useDispatch();

  const {
    createAccResponse,
    verifiedPropertiesList,
    propertyListLoader,
    deletedPropertyResponse,
    addMultiplePropertiesResponse,
    paymentData,
    paymnetLoader,
  } = useSelector((state) => state.signUpUser);

  const {
    getPropertyData,
    selectedProperty: selectedPropertyData,
    propertyQuestion,
    propertyLoader,
    selectedUserID,
    isQuestionByPass,
    isSubscriptionByPass,
    editPropertiesDetails,
  } = useSelector((state) => state.properties);
  const { data: userData } = useSelector(
    (state) => state?.userProfile?.userProfileDetails,
  );

  const addNewProperty = (action) => {
    dispatch(userSigupAction.addNewProperty({}));
    dispatch(propertiesAction.addNewProperty({}));
    dispatch(propertiesAction.setIsQuestionByPass(false));
    dispatch(userSigupAction.fetchDefaultOwnerNameData({}));
    if (action === "clearVerifiedPropertiesList") {
      dispatch(userSigupAction.clearPropertyVerified({}));
    }

    // Clear create-form search leftovers so Find Property does not auto-add
    // the previous address via generate-questions.
    localStorage.removeItem("param");
    localStorage.removeItem("formParams");
    localStorage.removeItem("searched_Add");
    localStorage.removeItem("searched_Add_popup");
    localStorage.removeItem("property_search_data");
    localStorage.removeItem("button");

    // When at least one property is already verified, allow skipping Find Property.
    const verifiedCount = Array.isArray(verifiedPropertiesList?.data)
      ? verifiedPropertiesList.data.filter((property) => !property?.not_added)
          .length
      : 0;
    if (
      (isResumeSignup || isAdminCreateUser) &&
      verifiedPropertiesList?.success &&
      verifiedCount >= 1
    ) {
      localStorage.setItem("button", "skip");
    }

    onChangeModalScreen("security");
  };

  const propertyAction = (event, type, data) => {
    console.log("Selected row type==>", type, "==Data==>", data);

    if (type === "verify") {
      if (Object.keys(data)?.length > 0) {
        let propertyData = data?.json_res;

        let inputParams = {
          state_code: propertyData.mm_fips_state_code,
          property_id: data?.property_id,
          muni_code: propertyData.mm_fips_muni_code,
          sa_y_coord: propertyData.sa_y_coord,
          sa_x_coord: propertyData.sa_x_coord,
          user_id: user_id || data?.owner_id || data?.user_id,
          address: data.address,
          country: data.country || "USA",
          city: data.city,
          state: data.state,
          zip: data.zip,
          latitude: data.latitude,
          longitude: data.longitude,
          bed_rooms: data.bed_rooms,
          baths: data.baths,
          sqft: data.sqft,
          year_built: data.year_built,
          json_response: propertyData,
          price: data.price || 0,
          county: data.county,
          //check_county: county_name ? true : false,
          from_investor: data?.from_investor,
          from_resume: true,
          step: 2,
          step_key: "GENERATE_QUESTIONS",
        };
        console.log("security questions==>", inputParams);
        dispatch(
          propertiesAction.selectedUserPropertyData({
            ...data,
            from_resume: true,
          }),
        );

        setTimeout(() => {
          delete inputParams.step;
          delete inputParams.step_key;
          dispatch(propertiesAction.generateQuestionsInputParams(data));
        }, 3000);

        dispatch(
          propertiesAction.generateQuestions({
            url: mapCreateUserApiUrl(
              "admin/properties/generate-questions",
              isServiceProvider,
            ),
            data: inputParams,
            token: true,
          }),
        );
      }
      // setViewPropertyListScreen(true);
      // setPropertyListScreen(false);
      localStorage.setItem("button", "propertyList");
      // onChangeModalScreen("questions");
      // backtoAddProperty(2, "propertyList");
      // setOwnerScreen(false);
      // localStorage.setItem("isOwnerVerified", 0);
    }

    if (type === "delete") {
      let ipParams = {
        // user_id: data?.owner_id,
        user_id: data?.owner_id || data?.user_id,
        property_id: data?.property_id,
      };
      if (category !== "complete_protection") {
        ipParams.report_id = data?.id;
      }
      setParams(ipParams);
      setPropertyName(data?.address);
      setOpenDeletePopup(true);
      console.log("user_id==>", ipParams);
    }
  };

  const resolvedOwnerUserId =
    createAccResponse?.data?.user_id || user_id || selectedUserID || null;

  const APICall = () => {
    dispatch(
      userSigupAction.getPropertiesList({
        url: mapCreateUserApiUrl("admin/properties/list", isServiceProvider),
        token: !isAssistant,
        brokertoken: isAssistant,
        data: {
          user_id: resolvedOwnerUserId,
        },
      }),
    );
  };

  const OwnerCardStyle = {
    background: "rgb(21 190 83 / 5%)",
    boxShadow: "0px 17.0825px 39.8592px -5.69417px rgba(0, 0, 0, 0.15);",
    borderRadius: "3px",
    py: 2,
    px: 4,
    // border: '1px solid #15be53',
    fontWeight: "600",
    fontSize: "20px",
    lineHeight: "55px",
    color: "#0D120B",
  };

  useEffect(() => {
    APICall();
  }, []);

  // Prefetch mailing address while Owner Verification loads so card / paid-at-
  // closing billing can use state/address without re-fetching mid-payment.
  // Kept in Redux until signup clearData / resetSignupState after payment.
  useEffect(() => {
    if (!resolvedOwnerUserId) {
      return;
    }
    dispatch(
      userSigupAction.getMailingAddress({
        url: "get-mailing-address",
        data: {
          user_id: resolvedOwnerUserId,
          step: 2,
          step_key: "GET_MAILING_ADDRESS",
        },
      }),
    );
  }, [dispatch, resolvedOwnerUserId]);

  useEffect(() => {
    if (propertyListLoader) {
      return;
    }

    if (isAdminCreateUser && skipVerification) {
      return;
    }

    if (isAdminCreateUser && !getObjLength(verifiedPropertiesList)) {
      return;
    }

    if (
      getObjLength(verifiedPropertiesList) &&
      verifiedPropertiesList?.success &&
      verifiedPropertiesList?.data?.length === 0
    ) {
      addNewProperty("clearVerifiedPropertiesList");
    }
  }, [
    verifiedPropertiesList,
    propertyListLoader,
    isAdminCreateUser,
    skipVerification,
  ]);

  useEffect(() => {
    if (!skipVerification) {
      return;
    }

    if (
      verifiedPropertiesList?.success &&
      verifiedPropertiesList?.data?.length > 0
    ) {
      setSkipVerification(false);
    }
  }, [verifiedPropertiesList, skipVerification, setSkipVerification]);

  // let verified = verifiedPropertiesList?.data?.find(
  //   (i, j) => i?.is_verified === 0
  // );
  const property_not_added = verifiedPropertiesList?.data?.filter(
    (proeprty, key) => proeprty?.not_added,
  );
  const getSelectedPropertiesPayload = () => {
    const listedProperties = Array.isArray(verifiedPropertiesList?.data)
      ? verifiedPropertiesList.data.filter((property) => !property?.not_added)
      : [];
    return buildSignupPropertiesIdPayload(listedProperties);
  };

  const executeNextStep = (nextCategory = category) => {
    setFromPropertyList(true);
    const { propertyIds, properties, ids } = getSelectedPropertiesPayload();
    console.log(propertyIds, "propertyIds==>", properties);
    // Stage every Owner Verification property_id for get-final-amount / post-payment.
    dispatch(userSigupAction.setPropertiesId({ propertyIds, properties, ids }));
    setAdminChangeCategory(nextCategory);
    // County investor pricing (investors-price-details) is Complete Protection
    // only; paid Enhanced uses the standard Enhanced plan.
    if (isCountyInvestorUser) {
      dispatch(
        userSigupAction.fetchInvestorID(
          nextCategory === "enhanced_monitoring"
            ? null
            : selectedRowData?.investor_id || selectedRowData?.county_user_id,
        ),
      );
    }
    if (nextCategory === "basic_monitoring") {
      // Basic monitoring skips the security PIN step and completes directly.
      finishMonitoringSignup();
    } else {
      // Enhanced → Activate Plan; Complete Protection → Yearly / Bill me at closing.
      localStorage.setItem("category", encryptPayload(nextCategory));
      onChangeModalScreen("subscriptions");
    }
    setIsPropertyAdded(true);
    setOpenAdminCustomerCategoryModal(false);
  };

  const rowCategory =
    selectedRowData?.category != null && selectedRowData?.category !== ""
      ? selectedRowData.category
      : category;

  // County-site users get complimentary Enhanced only when resuming Enhanced;
  // a Complete Protection signup continues the normal paid flow.
  const isEldoradoUser =
    isEldoradoFromWhere(selectedRowData) &&
    rowCategory !== "complete_protection";
  const isAffiliateComplimentaryUser =
    isAffiliateUser(selectedRowData) || isAffiliateUser();
  const isComplimentaryEnhancedUser =
    isComplimentaryEnhancedMonitoringUser(selectedRowData);
  const isCountyInvestorUser = Boolean(
    selectedRowData?.county_user_id || selectedData?.county_user_id,
  );
  const isComplimentaryEnhancedResumeUser =
    isEldoradoUser ||
    isAffiliateComplimentaryUser ||
    isComplimentaryEnhancedUser;

  const shouldShowAdminCustomerCategoryModal =
    shouldPromptAdminCustomerCategoryConfirm(isAdmin, selectedRowData) &&
    !isComplimentaryEnhancedResumeUser;

  // County investors on Enhanced default to their complimentary plan; paid
  // Enhanced and Complete Protection stay available under "choose different".
  const isCountyInvestorEnhanced =
    isCountyInvestorUser && rowCategory === "enhanced_monitoring";

  const resolvedCategoryForConfirm = isCountyInvestorEnhanced
    ? ENHANCED_MONITORING_COMPLIMENTARY
    : rowCategory;

  const canOfferAdminComplimentaryEnhanced =
    isLoggedInSuperOrInternalAdmin(userData) || isCountyInvestorEnhanced;

  const enrollComplimentaryEnhancedMonitoring = (
    isAdminComplimentary = false,
    { forceAdminFreeEnhanced = false } = {},
  ) => {
    const userId =
      createAccResponse?.data?.user_id || user_id || selectedUserID || null;
    const listedProperties = Array.isArray(verifiedPropertiesList?.data)
      ? verifiedPropertiesList.data.filter((property) => !property?.not_added)
      : [];
    // Admin properties/list rows: id is the risk report id for enhanced flows.
    const riskReportIds = Array.from(
      new Set(
        listedProperties
          .map((property) =>
            Number(
              property?.risk_report_id ?? property?.report_id ?? property?.id,
            ),
          )
          .filter((id) => Number.isFinite(id) && id > 0),
      ),
    );

    if (!userId || !riskReportIds.length) {
      setComplimentaryEnrollResult({
        success: false,
        message:
          "Unable to activate Complimentary Enhanced Monitoring for this user. Please try again.",
      });
      setShowComplimentaryResult(true);
      return;
    }

    const { propertyIds, properties, ids } = getSelectedPropertiesPayload();
    dispatch(userSigupAction.setPropertiesId({ propertyIds, properties, ids }));
    setAdminChangeCategory("enhanced_monitoring");
    localStorage.setItem("category", encryptPayload("enhanced_monitoring"));
    setFromPropertyList(true);
    setComplimentaryEnrollResult({ success: false, message: "" });
    setShowComplimentaryResult(false);
    dispatch(userSigupAction.fetchPaymentData({}));
    pendingComplimentaryEnhancedRef.current = true;
    dispatch(
      userSigupAction.getPayment({
        url: "payment-enhanced-monitoring",
        data: {
          user_id: userId,
          risk_report_id: riskReportIds,
          ...complimentaryEnhancedFreeFlagPayload(isAdminComplimentary, {
            isCountyInvestor:
              !forceAdminFreeEnhanced &&
              isCountyInvestorUser &&
              !isEldoradoUser,
          }),
        },
        token: true,
      }),
    );
  };

  const handleNextClick = () => {
    // Eldorado customer resume: csi_free_enhanced. Affiliate admin resume uses
    // admin_free_enhanced, unless the selected user has county_user_id
    // (county_investor_free_enhanced). is_affiliate_user is for user signup only.
    if (isEldoradoUser) {
      enrollComplimentaryEnhancedMonitoring(false);
      return;
    }
    if (isAffiliateComplimentaryUser || isComplimentaryEnhancedUser) {
      enrollComplimentaryEnhancedMonitoring(true);
      return;
    }
    if (shouldShowAdminCustomerCategoryModal) {
      setOpenAdminCustomerCategoryModal(true);
      return;
    }
    executeNextStep(category);
  };

  useEffect(() => {
    const state = autoContinueRef.current;
    if (!autoContinue || state.done) {
      return;
    }
    // Wait for this page's own list request, not a list left from earlier.
    if (propertyListLoader) {
      state.requested = true;
      return;
    }
    if (!state.requested) {
      return;
    }
    const listed = Array.isArray(verifiedPropertiesList?.data)
      ? verifiedPropertiesList.data.filter((property) => !property?.not_added)
      : [];
    state.done = true;
    if (!verifiedPropertiesList?.success || !listed.length) {
      setAutoContinueFailed(true);
      return;
    }
    handleNextClick();
  }, [autoContinue, propertyListLoader, verifiedPropertiesList, handleNextClick]);

  const closeAdminCategoryModal = () => {
    setOpenAdminCustomerCategoryModal(false);
    setAddMultiplePropertiesError("");
    setShowAddMultiplePropertiesSuccess(false);
    setSelectedUpgradeCategory("");
    dispatch(userSigupAction.clearAddMultiplePropertiesResponse());
  };

  const handleAdminCategoryContinue = (nextCategory) => {
    if (
      nextCategory === ENHANCED_MONITORING_COMPLIMENTARY &&
      canOfferAdminComplimentaryEnhanced
    ) {
      setOpenAdminCustomerCategoryModal(false);
      enrollComplimentaryEnhancedMonitoring(true, {
        // County investors keep the county flag; others get admin_free_enhanced.
        forceAdminFreeEnhanced: !isCountyInvestorEnhanced,
      });
      return;
    }

    const oldCategory = rowCategory;
    const isUpgradeCategory =
      nextCategory !== oldCategory &&
      (nextCategory === "enhanced_monitoring" ||
        nextCategory === "complete_protection");

    console.log("nextCategory", nextCategory);
    console.log("oldCategory", oldCategory);

    if (isUpgradeCategory) {
      setSelectedUpgradeCategory(nextCategory);
      const { ids } = getSelectedPropertiesPayload();
      dispatch(
        userSigupAction.addMultipleProperties({
          url: mapCreateUserApiUrl(
            "admin/properties/add-multiple",
            isServiceProvider,
          ),
          token: true,
          data: {
            user_id:
              createAccResponse?.data?.user_id || user_id || selectedUserID,
            properties: (ids || []).map((id) => ({
              id,
              is_questions_verified_by_admin: true,
              subscribed_by_admin: true,
            })),
            category: nextCategory,
          },
        }),
      );
      return;
    }
    executeNextStep(nextCategory);
  };

  const handleDeleteProperty = () => {
    let url = mapCreateUserApiUrl("admin/properties/delete", isServiceProvider);
    if (category !== "complete_protection") {
      url = "properties/delete-property-report";
    }
    dispatch(
      userSigupAction.deleteProperties({
        url,
        data: params,
        token: true,
      }),
    );
    setOpenDeletePopup(false);
  };

  useEffect(() => {
    if (getObjLength(propertyQuestion) && category === "complete_protection") {
      if (!propertyQuestion?.success) {
        setPropertyQuestionPopup(true);
      }
      if (propertyQuestion?.success) {
        if (propertyQuestion?.data?.questions?.length > 0) {
          onChangeModalScreen("questions");
          setPropertyQuestionPopup(false);
        } else {
          if (
            isAdminCreateUser &&
            (propertyQuestion?.data?.is_verified ||
              propertyQuestion?.data?.length === 0)
          ) {
            setPropertyQuestionPopup(false);
          } else {
            setPropertyQuestionPopup(true);
          }
        }
      }
    }
  }, [propertyQuestion]);

  useEffect(() => {
    if (!getObjLength(addMultiplePropertiesResponse)) return;
    if (addMultiplePropertiesResponse?.success) {
      setAddMultiplePropertiesError("");
      setShowAddMultiplePropertiesSuccess(true);
      return;
    }
    setAddMultiplePropertiesError(
      addMultiplePropertiesResponse?.data?.message ||
        addMultiplePropertiesResponse?.message ||
        "Unable to continue with complete protection. Please try again.",
    );
  }, [
    addMultiplePropertiesResponse,
    dispatch,
    onChangeModalScreen,
    setAdminChangeCategory,
    setFromPropertyList,
    setIsPropertyAdded,
    verifiedPropertiesList,
  ]);

  useEffect(() => {
    if (!pendingComplimentaryEnhancedRef.current) {
      return;
    }
    if (paymnetLoader) {
      return;
    }
    if (!getObjLength(paymentData)) {
      return;
    }

    pendingComplimentaryEnhancedRef.current = false;
    if (paymentData?.success) {
      setComplimentaryEnrollResult({
        success: true,
        message:
          paymentData?.message ||
          paymentData?.data?.message ||
          "Complimentary Enhanced Monitoring activated for this El Dorado County property.",
      });
      setShowComplimentaryResult(true);
      return;
    }

    setComplimentaryEnrollResult({
      success: false,
      message:
        paymentData?.message ||
        paymentData?.data?.message ||
        "Unable to activate Complimentary Enhanced Monitoring.",
    });
    setShowComplimentaryResult(true);
  }, [paymentData, paymnetLoader]);

  if (autoContinue && !autoContinueFailed) {
    return <Loader open={true} />;
  }

  return (
    <>
      {isTailwindComponent ? (
        <div className="tailwind_component">
          <OwnerVerificationV2
            propertiesList={verifiedPropertiesList}
            propertyAction={propertyAction}
            addedNewProperty={addNewProperty}
            addNewProperty={addNewProperty}
            isAdminFlow={true}
            onAdminNext={handleNextClick}
            onAddAnotherProperty={addNewProperty}
            hideAddAnotherProperty={hideAddAnotherProperty}
            isAssistant={isAssistant}
            isAdmin={isAdmin}
          />
        </div>
      ) : (
        <Box className="accountBoxWrapper bg-white">
          <Typography align="center" variant="h3">
            Owner Verified
          </Typography>
          <Typography align="center" variant="body1">
            Your Ownership of the below property has been verified by
            EquityProtect.
          </Typography>
          <Grid
            container
            spacing={2}
            justifyContent={`${
              verifiedPropertiesList?.data?.length > 1 ? "" : "center"
            }`}
          >
            {verifiedPropertiesList?.success ? (
              verifiedPropertiesList?.data?.map(
                (data, key) =>
                  !data?.not_added && (
                    <>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        className="text-start"
                      >
                        <Box sx={{ position: "relative", mb: 3 }}>
                          <Paper
                            className="verifiedOwnerCard"
                            sx={OwnerCardStyle}
                          >
                            <Box>
                              <Typography
                                variant="h3"
                                sx={{ minHeight: "52px" }}
                              >
                                Property: {data?.address}
                              </Typography>
                              <Typography variant="h3">
                                City: {data?.city}
                              </Typography>
                              <Typography variant="h3">
                                State: {data?.state}
                              </Typography>
                              <Typography variant="h3">
                                Country: {data?.country || "USA"}
                              </Typography>
                              <Typography variant="h3">
                                Zip: {data?.zip}
                              </Typography>
                            </Box>
                            <Box
                              className={`d-flex ${
                                data?.is_verified === 0
                                  ? `justify-content-between`
                                  : `justify-content-end`
                              } pt-4`}
                            >
                              {data?.is_verified === 0 ? (
                                <Tooltip
                                  title={"Verify this property"}
                                  TransitionComponent={Zoom}
                                  placement="top"
                                  arrow
                                  disableFocusListener
                                >
                                  <Button
                                    className="px-4"
                                    onClick={(e) =>
                                      propertyAction(e, "verify", data)
                                    }
                                    variant="contained"
                                    color="success"
                                  >
                                    Verify
                                  </Button>
                                </Tooltip>
                              ) : null}
                              {verifiedPropertiesList?.data?.length > 1 &&
                                !isAssistant && (
                                  <Tooltip
                                    title={"Delete this property"}
                                    TransitionComponent={Zoom}
                                    placement="top"
                                    arrow
                                    disableFocusListener
                                  >
                                    <IconButton
                                      variant="contained"
                                      onClick={(e) =>
                                        propertyAction(e, "delete", data)
                                      }
                                      color="error"
                                    >
                                      <DeleteIcon sx={{ fontSize: "30px" }} />
                                    </IconButton>
                                  </Tooltip>
                                )}
                            </Box>
                          </Paper>
                          {data?.is_verified === 1 ? (
                            <>
                              <div className="verifiedOwnerbadge">
                                <VerifiedUserIcon
                                  color="success"
                                  sx={{ textAlign: "center" }}
                                />
                              </div>
                            </>
                          ) : null}
                        </Box>
                      </Grid>
                    </>
                  ),
              )
            ) : verifiedPropertiesList?.data?.message?.length > 0 ? (
              <p className="text-danger">
                {verifiedPropertiesList?.data?.message}
              </p>
            ) : (
              <Loader open={propertyListLoader} />
            )}

            {/* To display investors properties which are not added due to lack of data */}
            {verifiedPropertiesList?.success ? (
              property_not_added?.length > 0 ? (
                <Grid item xs={12} sm={12} md={12}>
                  <Box sx={{ position: "relative", mb: 3 }}>
                    <Paper className="verifiedOwnerCard" sx={OwnerCardStyle}>
                      <Box>
                        <Typography
                          variant="h3"
                          sx={{ fontSize: "18px !important" }}
                        >
                          The following properties could not be added due to
                          insufficient data. Please add them manually or Call us
                          at{" "}
                          <a href={`tel:${PROPERTY_RISK_SUPPORT_PHONE}`}>
                            {PROPERTY_RISK_SUPPORT_PHONE_FORMAT}
                          </a>{" "}
                          and ask for the Investors Department.
                        </Typography>
                        <Grid item container>
                          {verifiedPropertiesList?.success
                            ? property_not_added?.map((data, key) => (
                                <Grid xs={12} sm={12} md={6} lg={6}>
                                  <Paper
                                    className="verifiedOwnerCard m-2"
                                    sx={{
                                      ...OwnerCardStyle,
                                      boxShadow: "none",
                                      paddingLeft: "10px",
                                      paddingRight: "10px",
                                      border: "1px solid rgb(21 190 83 / 78%)",
                                    }}
                                  >
                                    <Box>
                                      <Typography
                                        className="text-dark fw-500"
                                        variant="h6"
                                        sx={{
                                          fontSize: "16px !important",
                                          lineHeight: "25px",
                                        }}
                                      >
                                        {`${key + 1}) ${data?.address || "-"}`}
                                      </Typography>
                                    </Box>
                                  </Paper>
                                </Grid>
                              ))
                            : null}
                        </Grid>
                      </Box>
                    </Paper>
                  </Box>
                </Grid>
              ) : null
            ) : null}
          </Grid>
          <Box align="center" mt={3}>
            {/* Still offered with no property left, so the agent is not stuck. */}
            {(!hideAddAnotherProperty ||
              !verifiedPropertiesList?.data?.length) && (
              <Button
                className="popup_Btn other_popup_btn"
                variant="contained"
                onClick={addNewProperty}
              >
                Add Another Property
              </Button>
            )}
            <Button
              onClick={handleNextClick}
              // disabled={verifiedPropertiesList?.data?.length === 0}
              type="submit"
              className={`popup_Btn success_popup_btn m-2`}
              variant="contained"
            >
              Next
            </Button>
          </Box>
        </Box>
      )}

      {openDeletePopup && (
        <AlertDialog
          type="Attention"
          openPopup={openDeletePopup}
          onClose={true}
          onCloseFun={() => setOpenDeletePopup(false)}
          mesage={
            <>
              Are you sure you want to delete <b>{propertyName}</b> address?
            </>
          }
          buttons={
            <div className="text-center stepBtn mt-4 ">
              <Button
                onClick={() => {
                  setOpenDeletePopup(false);
                }}
                className="popup_Btn other_popup_btn"
                variant="contained"
              >
                No,Close
              </Button>
              <Button
                onClick={() => {
                  handleDeleteProperty();
                }}
                className="popup_Btn success_popup_btn mx-3"
                variant="contained"
              >
                Yes,Delete
              </Button>
            </div>
          }
        />
      )}

      {getObjLength(deletedPropertyResponse) ? (
        deletedPropertyResponse?.success ? (
          <AlertDialog
            type="Success"
            openPopup={true}
            onClose={false}
            mesage={`Property removed successfully.`}
            buttons={
              <div className="text-center stepBtn mt-4">
                <Button
                  onClick={() => {
                    APICall();
                    setOpenDeletePopup(false);
                    dispatch(userSigupAction.clearDeletePropertiesResponse());
                  }}
                  className="next_button "
                  variant="contained"
                >
                  Okay, All Good.
                </Button>
              </div>
            }
          />
        ) : (
          <AlertDialog
            type="Error"
            openPopup={true}
            onClose={false}
            mesage={deletedPropertyResponse?.data?.message}
            buttons={
              <div className="text-center stepBtn mt-4">
                <Button
                  className="popup_Btn error_popup_btn "
                  onClick={() => {
                    // setOpenDeletePopup(false);
                    dispatch(userSigupAction.clearDeletePropertiesResponse());
                  }}
                >
                  ok, Close
                </Button>
              </div>
            }
          />
        )
      ) : null}

      <AdminCustomerCategoryModal
        open={openAdminCustomerCategoryModal}
        onClose={closeAdminCategoryModal}
        resolvedCategoryForConfirm={resolvedCategoryForConfirm}
        onContinue={handleAdminCategoryContinue}
        showComplimentaryEnhancedOption={canOfferAdminComplimentaryEnhanced}
      />

      {propertyQuestionPopup && (
        <AlertDialog
          type="Error"
          openPopup={propertyQuestionPopup}
          onClose={true}
          onCloseFun={() => {
            setPropertyQuestionPopup(false);
            localStorage.setItem("button", "noButton");
            dispatch(propertiesAction.setGeneratedQuestionsData({}));
          }}
          mesage={
            propertyQuestion?.success &&
            propertyQuestion?.data?.questions?.length === 0
              ? "We were unable to retrieve the property questions. Please complete your signup and verify your property with the necessary property documents."
              : propertyQuestion?.data?.message
          }
        />
      )}

      {addMultiplePropertiesError?.length > 0 && (
        <AlertDialog
          type="Error"
          openPopup={true}
          onClose={false}
          mesage={addMultiplePropertiesError}
          buttons={
            <div className="text-center stepBtn mt-4">
              <Button
                className="popup_Btn error_popup_btn "
                onClick={() => {
                  setAddMultiplePropertiesError("");
                  dispatch(
                    userSigupAction.clearAddMultiplePropertiesResponse(),
                  );
                }}
              >
                ok, Close
              </Button>
            </div>
          }
        />
      )}

      {showAddMultiplePropertiesSuccess && (
        <AlertDialog
          type="Success"
          openPopup={true}
          onClose={false}
          mesage={
            addMultiplePropertiesResponse?.data?.message ||
            addMultiplePropertiesResponse?.message
            //||"Properties added successfully."
          }
          buttons={
            <div className="text-center stepBtn">
              <Button
                className="popup_Btn success_popup_btn mx-3"
                onClick={() => {
                  setShowAddMultiplePropertiesSuccess(false);
                  setFromPropertyList(true);
                  const { propertyIds, properties, ids } =
                    getSelectedPropertiesPayload();
                  dispatch(
                    userSigupAction.setPropertiesId({
                      propertyIds,
                      properties,
                      ids,
                    }),
                  );
                  setAdminChangeCategory(selectedUpgradeCategory || category);
                  dispatch(
                    userSigupAction.clearAddMultiplePropertiesResponse(),
                  );
                  onChangeModalScreen("subscriptions");
                  setIsPropertyAdded(true);
                  setOpenAdminCustomerCategoryModal(false);
                }}
              >
                Next
              </Button>
            </div>
          }
        />
      )}

      {showComplimentaryResult ? (
        <AlertDialog
          isTailwindComponent={isTailwindComponent}
          type={complimentaryEnrollResult.success ? "Success" : "Error"}
          openPopup={true}
          onClose={true}
          onCloseFun={() => {
            const succeeded = complimentaryEnrollResult.success;
            setShowComplimentaryResult(false);
            setComplimentaryEnrollResult({ success: false, message: "" });
            dispatch(userSigupAction.fetchPaymentData({}));
            if (succeeded) {
              setIsPropertyAdded(true);
              // Enhanced resume (incl. Eldorado / admin complimentary): welcome —
              // no PIN / beneficiaries. Matches other complimentary Enhanced users.
              if (isResumeSignup) {
                onChangeModalScreen("welcome");
                return;
              }
              dispatch(propertyUsersAction.fetchSecurityPINData({}));
              onChangeModalScreen("security-pin");
            }
          }}
          mesage={complimentaryEnrollResult.message}
          footer={false}
        />
      ) : null}

      <Loader
        open={
          propertyListLoader ||
          propertyLoader ||
          Boolean(
            paymnetLoader &&
            (isComplimentaryEnhancedResumeUser ||
              pendingComplimentaryEnhancedRef.current),
          )
        }
      />
    </>
  );
};

export default OwnerVerification;
